<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Service Contracts</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            :headers="headersNotfound"
            :items-per-page="5"
            :items="itemNotfound"
            hide-default-footer
            loading-text="Loading... Please wait"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
            </template>
          </v-data-table>
          <v-data-table
            v-else
            :headers="contractHeader"
            :items-per-page="5"
            :items="headerItemsFilterDate"
            class="elevation-1 table-header"
            hide-default-footer
            @click:row="handleRowClick"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
              <v-dialog v-model="dialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Contract Information</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <div v-for="(header, idx) in contractHeader" :key="idx">
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-if="checkIsEmpty(curContact[header.value])"
                              v-model="emptyItem"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                            <v-text-field
                              color="black"
                              v-else
                              v-model="curContact[header.value]"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close">
                      OK
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="seeDetail">
                      See Contract Details
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template
              v-for="header in contractHeader"
              v-slot:[`item.${header.value}`]="{ item }"
            >
              <template v-if="isBoolean(item[header.value])">
                <div class="checkbox_container" v-bind:key="item[header.value]">
                  <v-checkbox
                    v-bind:key="item[header.value]"
                    v-model="item[header.value]"
                    :true-value="true"
                    :false-value="false"
                    light
                    disabled
                    color="black"
                  ></v-checkbox>
                </div>
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-top: 30px" id="detail">
        <v-expansion-panel-header class="Header"
          >Contract Details</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search2"
          />
          <br />
          <tableComponent
            :tableHeaders="contractDetail"
            :tableItems="detailItemsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-top: 30px">
        <v-expansion-panel-header class="Header"
          >Contract Renewal</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search3"
          />
          <br />
          <tableComponent
            :tableHeaders="contractRenewal"
            :tableItems="renewalItemsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";
export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(3).keys());
        this.getBAQContract();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = this.todate3 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 =
          this.fromdate2 =
          this.fromdate3 =
            `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      modelTrue: true,
      modelFalse: false,
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      contractHeader: [
        { text: "Active Date", value: "FSContHd_ActiveDate" },
        { text: "Expire Date", value: "FSContHd_ExpireDate" },
        { text: "Customer", value: "Customer_Name" },
        { text: "Shipto", value: "FSContHd_ShipToNum" },
        { text: "Contract Num", value: "FSContHd_ContractNum" },
        { text: "Type", value: "FSContHd_ContractType" },
        { text: "On Site", value: "FSContHd_OnSite" },
        { text: "Currency Code", value: "FSContHd_CurrencyCode" },
        { text: "Duration", value: "FSContHd_Duration" },
        { text: "Modifier", value: "FSContHd_Modifier" },
        { text: "Material", value: "FSContHd_Material" },
        { text: "Labor", value: "FSContHd_Labor" },
        { text: "Miscellaneous", value: "FSContHd_Misc" },
        { text: "Invoiced", value: "FSContHd_Invoiced" },
        { text: "Recurring Inv", value: "FSContHd_RecurringInv" },
        { text: "RecFrequency", value: "FSContHd_RecurringFreq" },
        { text: "PricePer", value: "FSContHd_PricePer" },
        { text: "Last Invoice", value: "FSContHd_LastInvGen" },
        { text: "InvoiceNum", value: "FSContHd_InvoiceNum" },
        { text: "QuoteNum", value: "FSContHd_QuoteNum" },
        { text: "QuoteLine", value: "FSContHd_QuoteLine" },
        { text: "Quote Accepted", value: "FSContHd_QuoteAccepted" },
        { text: "Order", value: "FSContHd_OrderNum" },
        { text: "OrderLine", value: "FSContHd_OrderLine" },
        { text: "PackNum", value: "FSContHd_PackNum" },
        { text: "PackLine", value: "FSContHd_PackLine" },
        { text: "Renewable", value: "FSContHd_Renewable" },
        { text: "CallType", value: "FSContHd_CallType_c" },
        { text: "ScheDate", value: "FSContHd_ScheDate_c" },
        { text: "Frequency", value: "FSContHd_Frequency_c" },
        { text: "Entered", value: "FSContHd_EntryDate" },
        { text: "Contract Type", value: "FSContHd_ContractCode" },
        { text: "ContractComment", value: "FSContHd_ContractComment" },
        { text: "InvoiceComment", value: "FSContHd_InvoiceComment" },
      ],
      contractDetail: [
        { text: "Company", value: "FSContDt_Company" },
        { text: "ContractNum", value: "FSContDt_ContractNum" },
        { text: "Customer", value: "FSContDt_CustNum" },
        { text: "Line", value: "FSContDt_ContractLine" },
        { text: "ContractCode", value: "FSContDt_ContractCode" },
        { text: "Type", value: "FSContDt_ContractType" },
        { text: "Part", value: "FSContDt_PartNum" },
        { text: "Rev", value: "FSContDt_RevisionNum" },
        { text: "Description", value: "FSContDt_LineDesc" },
        { text: "UOM", value: "FSContDt_IUM" },
        { text: "Contract Price", value: "FSContDt_PricePerUnit" },
        { text: "Doc Unit Price", value: "FSContDt_DocPricePerUnit" },
        { text: "Contract Qty", value: "FSContDt_ContractQty" },
        { text: "Group", value: "FSContDt_ProdCode" },
        { text: "Cust Part", value: "FSContDt_XPartNum" },
        { text: "Project ID", value: "FSContDt_ProjectID" },
        { text: "Inactive", value: "FSContDt_Inactive" },
        { text: "Code", value: "Calculated_Code" },
        { text: "Invoiced", value: "FSContDt_Invoiced" },
        { text: "Billing Start Date", value: "FSContDt_BillStartDate" },
        { text: "Bill End Date", value: "FSContDt_BillEndDate" },
        { text: "Material", value: "FSContHd_Material" },
        { text: "Labor", value: "FSContHd_Labor" },
        { text: "Miscellaneous", value: "FSContHd_Misc" },
        { text: "CntDescription", value: "Calculated_CntDescription" },
        { text: "Project Description", value: "Project_Description" },
        { text: "Track Lots", value: "Part_TrackLots" },
        { text: "Track Serial", value: "Part_TrackSerialNum" },
      ],
      contractRenewal: [
        { text: "ContractNum", value: "FSRenewal_ContractNum" },
        { text: "Contract Code", value: "FSRenewal_ContractCode" },
        { text: "Description", value: "FSContCd_ContractDescription" },
        { text: "Renewal Number", value: "FSRenewal_RenewalNbr" },
        { text: "OrderNum", value: "FSRenewal_OrderNum" },
        { text: "OrderLine", value: "FSRenewal_OrderLine" },
        { text: "Renewal Code", value: "FSRenewal_RenewalCode" },
        { text: "Renewal Effective Date", value: "FSRenewal_RenewEffDate" },
        { text: "Renewed Until", value: "FSRenewal_RenewedUntil" },
        { text: "Duration", value: "FSRenewal_Duration" },
        { text: "Coverage Material", value: "FSRenewal_Material" },
        { text: "Coverage Labor", value: "FSRenewal_Labor" },
        { text: "Coverage Misc", value: "FSRenewal_Misc" },
        { text: "Coverage On Site", value: "FSRenewal_OnSite" },
        { text: "Invoiced", value: "FSRenewal_Invoiced" },
        { text: "Invoice", value: "FSRenewal_InvoiceNum" },
        { text: "Line", value: "FSRenewalDt_RenewalLine" },
        { text: "Part", value: "FSRenewalDt_PartNum" },
        { text: "Rev", value: "FSRenewalDt_RevisionNum" },
        { text: "Desc", value: "FSRenewalDt_LineDesc" },
        { text: "UOM", value: "FSRenewalDt_IUM" },
        { text: "Cust Part", value: "FSRenewalDt_XPartNum" },
        { text: "Revision", value: "FSRenewalDt_XRevisionNum" },
        { text: "Increase Percent", value: "FSRenewalDt_IncreasePct" },
        { text: "Renewal Price", value: "FSRenewalDt_DocPricePerUnit" },
        { text: "Serial Number", value: "FSContSN_SerialNumber" },
        { text: "Billing Start Date", value: "FSRenewalDt_BillStartDate" },
        { text: "Bill End Date", value: "FSRenewalDt_BillEndDate" },
      ],
      headerItems: [],
      detailItems: [],
      renewalItems: [],
      panel: [],
      curContact: {},
      search1: "",
      search2: "",
      search3: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
      fromdate3: "",
      todate3: "",
      dialog: false,
      emptyItem: " ",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getContractHead() {
      this.loadHeader();
    },
    getContractDtl() {
      this.loadDetail();
    },
    getContractRenewal() {
      this.loadDetail();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", [
      "getContractHead",
      "getContractDtl",
      "getContractRenewal",
    ]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return (
          i.FSContHd_ContractNum.toString().toLowerCase().indexOf(filterKey) >
          -1
        );
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.headerItemsFilter.filter((i) => {
          let day = i.FSContHd_ExpireDate.split("/")[0];
          let month = i.FSContHd_ExpireDate.split("/")[1];
          let year = i.FSContHd_ExpireDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.headerItemsFilter;
      }
    },
    detailItemsFilter() {
      const filterKey = (this.search2 || "").toLowerCase();
      if (this.detailItems == null || filterKey === "") return this.detailItems;
      return this.detailItems.filter((i) => {
        return (
          i.FSContDt_ContractLine.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSContDt_LineDesc.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSContDt_ContractCode.toString().toLowerCase().indexOf(filterKey) >
            -1
        );
      });
    },
    detailItemsFilterDate() {
      if (this.detailItemsFilter.length > 0) {
        return this.detailItemsFilter;
      } else {
        return this.detailItemsFilter;
      }
    },
    renewalItemsFilter() {
      const filterKey = (this.search3 || "").toLowerCase();
      if (this.renewalItems == null || filterKey === "")
        return this.renewalItems;
      return this.renewalItems.filter((i) => {
        return (
          i.FSRenewal_RenewalNbr.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSRenewal_OrderNum.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSRenewal_RenewalCode.toString().toLowerCase().indexOf(filterKey) >
            -1
        );
      });
    },
    renewalItemsFilterDate() {
      if (this.renewalItemsFilter.length > 0) {
        return this.renewalItemsFilter;
      } else {
        return this.renewalItemsFilter;
      }
    },
  },
  methods: {
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    close() {
      this.dialog = false;
    },
    isBoolean(value) {
      return typeof value === "boolean";
    },
    seeDetail() {
      this.dialog = false;
      this.getBAQContractDetail(this.curContact);
      window.scrollTo({
        top: document.getElementById("detail").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
    handleRowClick(item) {
      this.curContact = item;
      this.dialog = true;
    },
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQContract() {
      await this.$store.dispatch("Data/getContractHeadData");
      this.loadHeader();
    },
    async getBAQContractDetail(item) {
      await this.$store.dispatch("Data/getContractDtlData", {
        contractnum: item.FSContHd_ContractNum,
        shipto: item.FSContHd_ShipToNum,
      });
      await this.$store.dispatch("Data/getContractRenewalData", {
        contractnum: item.FSContHd_ContractNum,
      });
      this.loadDetail();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getContractHead && this.getContractHead.length > 0) {
        this.getContractHead.forEach((el) => {
          this.headerItems.push({
            FSContHd_ActiveDate: this.convertDate(el.FSContHd_ActiveDate),
            FSContHd_ExpireDate: this.convertDate(el.FSContHd_ExpireDate),
            Customer_Name: el.Customer_Name,
            FSContHd_ShipToNum: el.FSContHd_ShipToNum,
            FSContHd_ContractNum: el.FSContHd_ContractNum,
            FSContHd_ContractType: el.FSContHd_ContractType,
            FSContHd_OnSite: el.FSContHd_OnSite,
            FSContHd_CurrencyCode: el.FSContHd_CurrencyCode,
            FSContHd_Duration: el.FSContHd_Duration,
            FSContHd_Modifier: el.FSContHd_Modifier,
            FSContHd_Material: el.FSContHd_Material,
            FSContHd_Labor: el.FSContHd_Labor,
            FSContHd_Misc: el.FSContHd_Misc,
            FSContHd_Invoiced: el.FSContHd_Invoiced,
            FSContHd_RecurringInv: el.FSContHd_RecurringInv,
            FSContHd_RecurringFreq: el.FSContHd_RecurringFreq,
            FSContHd_PricePer: el.FSContHd_PricePer,
            FSContHd_LastInvGen: el.FSContHd_LastInvGen,
            FSContHd_InvoiceNum: el.FSContHd_InvoiceNum,
            FSContHd_QuoteNum: el.FSContHd_QuoteNum,
            FSContHd_QuoteLine: el.FSContHd_QuoteLine,
            FSContHd_QuoteAccepted: el.FSContHd_QuoteAccepted,
            FSContHd_OrderNum: el.FSContHd_OrderNum,
            FSContHd_OrderLine: el.FSContHd_OrderLine,
            FSContHd_PackNum: el.FSContHd_PackNum,
            FSContHd_PackLine: el.FSContHd_PackLine,
            FSContHd_Renewable: el.FSContHd_Renewable,
            FSContHd_CallType_c: el.FSContHd_CallType_c,
            FSContHd_ScheDate_c: el.FSContHd_ScheDate_c,
            FSContHd_Frequency_c: el.FSContHd_Frequency_c,
            FSContHd_EntryDate: this.convertDate(el.FSContHd_EntryDate),
            FSContHd_ContractCode: el.FSContHd_ContractCode,
            FSContHd_ContractComment: el.FSContHd_ContractComment,
            FSContHd_InvoiceComment: el.FSContHd_InvoiceComment,
          });
        });
      }
    },
    loadDetail() {
      this.detailItems = [];
      if (this.getContractDtl && this.getContractDtl.length > 0) {
        this.getContractDtl.forEach((el) => {
          this.detailItems.push({
            FSContDt_Company: el.FSContDt_Company,
            FSContDt_ContractNum: el.FSContDt_ContractNum,
            FSContDt_CustNum: el.FSContDt_CustNum,
            FSContDt_ContractLine: el.FSContDt_ContractLine,
            FSContDt_ContractCode: el.FSContDt_ContractCode,
            FSContDt_ContractType: el.FSContDt_ContractType,
            FSContDt_PartNum: el.FSContDt_PartNum,
            FSContDt_RevisionNum: el.FSContDt_RevisionNum,
            FSContDt_LineDesc: el.FSContDt_LineDesc,
            FSContDt_IUM: el.FSContDt_IUM,
            FSContDt_PricePerUnit: el.FSContDt_PricePerUnit,
            FSContDt_DocPricePerUnit: el.FSContDt_DocPricePerUnit,
            FSContDt_ContractQty: el.FSContDt_ContractQty,
            FSContDt_ProdCode: el.FSContDt_ProdCode,
            FSContDt_XPartNum: el.FSContDt_XPartNum,
            FSContDt_ProjectID: el.FSContDt_ProjectID,
            FSContDt_Inactive: el.FSContDt_Inactive,
            Calculated_Code: el.Calculated_Code,
            FSContDt_Invoiced: el.FSContDt_Invoiced,
            FSContDt_BillStartDate: this.convertDate(el.FSContDt_BillStartDate),
            FSContDt_BillEndDate: this.convertDate(el.FSContDt_BillEndDate),
            FSContHd_Material: el.FSContHd_Material,
            FSContHd_Labor: el.FSContHd_Labor,
            FSContHd_Misc: el.FSContHd_Misc,
            Calculated_CntDescription: el.Calculated_CntDescription,
            Project_Description: el.Project_Description,
            Part_TrackLots: el.Part_TrackLots,
            Part_TrackSerialNum: el.Part_TrackSerialNum,
          });
        });
      }
      this.renewalItems = [];
      if (this.getContractRenewal && this.getContractRenewal.length > 0) {
        this.getContractRenewal.forEach((el) => {
          this.renewalItems.push({
            FSRenewal_ContractNum: el.FSRenewal_ContractNum,
            FSRenewal_ContractCode: el.FSRenewal_ContractCode,
            FSContCd_ContractDescription: el.FSContCd_ContractDescription,
            FSRenewal_RenewalNbr: el.FSRenewal_RenewalNbr,
            FSRenewal_OrderNum: el.FSRenewal_OrderNum,
            FSRenewal_OrderLine: el.FSRenewal_OrderLine,
            FSRenewal_RenewalCode: el.FSRenewal_RenewalCode,
            FSRenewal_RenewEffDate: this.convertDate(el.FSRenewal_RenewEffDate),
            FSRenewal_RenewedUntil: this.convertDate(el.FSRenewal_RenewedUntil),
            FSRenewal_Duration: el.FSRenewal_Duration,
            FSRenewal_Material: el.FSRenewal_Material,
            FSRenewal_Labor: el.FSRenewal_Labor,
            FSRenewal_Misc: el.FSRenewal_Misc,
            FSRenewal_OnSite: el.FSRenewal_OnSite,
            FSRenewal_Invoiced: el.FSRenewal_Invoiced,
            FSRenewal_InvoiceNum: el.FSRenewal_InvoiceNum,
            FSRenewalDt_RenewalLine: el.FSRenewalDt_RenewalLine,
            FSRenewalDt_PartNum: el.FSRenewalDt_PartNum,
            FSRenewalDt_RevisionNum: el.FSRenewalDt_RevisionNum,
            FSRenewalDt_LineDesc: el.FSRenewalDt_LineDesc,
            FSRenewalDt_IUM: el.FSRenewalDt_IUM,
            FSRenewalDt_XPartNum: el.FSRenewalDt_XPartNum,
            FSRenewalDt_XRevisionNum: el.FSRenewalDt_XRevisionNum,
            FSRenewalDt_IncreasePct: el.FSRenewalDt_IncreasePct,
            FSRenewalDt_DocPricePerUnit: el.FSRenewalDt_DocPricePerUnit,
            FSContSN_SerialNumber: el.FSContSN_SerialNumber,
            FSRenewalDt_BillStartDate: this.convertDate(
              el.FSRenewalDt_BillStartDate
            ),
            FSRenewalDt_BillEndDate: this.convertDate(
              el.FSRenewalDt_BillEndDate
            ),
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.table td {
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ml-20 {
  margin-left: 100px;
}
.input_date {
  outline: #d1dfe3;
}
.filter_date {
  display: flex;
  flex-direction: row;
}
.filter_date_item {
  display: flex;
  flex-direction: column;
}
.mb-20 {
  margin-bottom: 50px;
}
.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}
.table-custom {
  width: 100%;
  margin-top: 20px;
}
table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}
th {
  border-bottom: 2px solid black;
}
td {
  text-align: center;
}
.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
}

.passwordRules {
  margin-top: -25px;
  margin-left: 15px;
  font-size: small;
  opacity: 0.6;
}
</style>
